module.exports = __webpack_public_path__ + "img/flow.f5b1e55b.png";